import React, { Component } from "react";
import { connect } from "react-redux";
import { actions as payActions } from "../../../../redux/modules/pay";
import { actions as userActions } from "../../../../redux/modules/user";
import { getYear } from "../../../../utils/tool";
import { get } from "../../../../utils/request";
import { jumpUrl } from "../../../../utils/tool";
import "../../../../index.css";
import "./style.css";
class PayNow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      payType: 1,
    };
  }
  componentDidMount = () => {
    this.requestUserInfo();
  };
  render() {
    const { visible, uiPay, discounts,userInfo } = this.props;
    return (
      <div className={visible === true ? "pay_box" : "pay_box display_none"}>
        <div className="pay_now_box">
          <div className="pay_now_top_box">
            <img
              className="fr"
              onClick={() => this.props.handleShowAndClosePayNow()}
              alt=""
              src={require("../../../../images/pay/X-55_47.png")}
            ></img>
            <div className="pay_now_top_info_box fl">
              <div>
                <div className="pay_img_box fl">
                  <img
                    alt=""
                    src={require("../../../../images/dayup/order.png")}
                  ></img>
                </div>
                <div className="fl major_left_10">
                  <div className="pay_money_box">
                    ￥<span>{uiPay.price}</span>
                  </div>
                  <div className="pay_money_box major_top_12">
                    {discounts > 0 ? "激活码已优惠￥" + discounts : ""}
                  </div>
                </div>
                <div className="clear"></div>
              </div>
              <div className="major_top_8 major_left_6">
                <span>面向浙江高中生家长</span>
              </div>
              <div className="major_top_4 major_left_6">
               <span>使用至<span style={{ color: "red" }
                  }>{userInfo.year}</span>年志愿录取结束</span>
              </div>
            </div>
          </div>
          <div className="pay_now_bottom_box">
            <div className="pay_choose display_none" >
              <div
                onClick={() => this.activateTab(0)}
                className={
                  uiPay.markArray[0]
                    ? "pay_choose_box_active fl"
                    : "pay_choose_box fl"
                }
              >
                高一
                <img
                  style={
                    uiPay.markArray[0]
                      ? { display: "block" }
                      : { display: "none" }
                  }
                  alt=""
                  src={require("../../../../images/search/search_0.png")}
                ></img>
              </div>
              <div
                onClick={() => this.activateTab(1)}
                className={
                  uiPay.markArray[1]
                    ? "pay_choose_box_active major_left_11_5 fl"
                    : "pay_choose_box major_left_11_5 fl"
                }
              >
                高二
                <img
                  style={
                    uiPay.markArray[1]
                      ? { display: "block" }
                      : { display: "none" }
                  }
                  alt=""
                  src={require("../../../../images/search/search_0.png")}
                ></img>
              </div>
              <div
                onClick={() => this.activateTab(2)}
                className={
                  uiPay.markArray[2]
                    ? "pay_choose_box_active major_left_11_5 fl"
                    : "pay_choose_box major_left_11_5 fl"
                }
              >
                高三
                <img
                  style={
                    uiPay.markArray[2]
                      ? { display: "block" }
                      : { display: "none" }
                  }
                  alt=""
                  src={require("../../../../images/search/search_0.png")}
                ></img>
              </div>
              <div className="clear"></div>
            </div>
            <div style={{height:30}}></div>
            <div

              onClick={() => this.props.requestPay(this.state.payType)}
              className="pay_btn"
            >
              微信支付
            </div>
          </div>
        </div>
      </div>
    );
  }
  /**
   * 切换tab
   * @param {} id
   */
  activateTab = (id) => {
    const { dispatch } = this.props;
    let tmpMarkArray = [0, 0, 0];
    tmpMarkArray[id] = 1;
    dispatch(payActions.setPayMarkArray(tmpMarkArray));

    let cYear = getYear();
    if (id === 0) {
      dispatch(payActions.setPayUseYear(cYear + 2));
      dispatch(payActions.setPayPrice("365.00"));
      this.setState({
        payType: 3,
      });
    } else if (id === 1) {
      dispatch(payActions.setPayUseYear(cYear + 1));
      dispatch(payActions.setPayPrice("365.00"));
      this.setState({
        payType: 2,
      });
    } else {
      dispatch(payActions.setPayUseYear(cYear));
      dispatch(payActions.setPayPrice("365.00"));
      this.setState({
        payType: 1,
      });
    }
  };
  /**
   * 请求用户信息
   */
  requestUserInfo = () => {
    const { dispatch } = this.props;
    let cYear = getYear();
    get("/public/v1/user/info").then((res) => {
      if (res.status === "success") {
        let userInfo = {
          phone: res.data.phone,
          year: res.data.year,
          isActive: res.data.isActive,
          isLogin: true,
          isBuy: res.data.isBuy,
          discounts: res.data.discounts,
          isWhiteUser: res.data.isWhiteUser,
        };
        dispatch(userActions.setUserInfo(userInfo));
        dispatch(userActions.setShowLogin(false));
        if (res.data.isBuy === true) {
          dispatch(userActions.setUserDayUpLink("/dayup"));
          jumpUrl("dayup");
        }
        let userYear =
          this.props.userInfo.year === "" ? cYear : this.props.userInfo.year;
        if (userYear <= cYear) {
          dispatch(payActions.setPayMarkArray([0, 0, 1]));
          dispatch(payActions.setPayUseYear(cYear));
          dispatch(payActions.setPayPrice("365.00"));
          this.setState({
            payType: 1,
          });
        } else if (userYear === cYear + 1) {
          dispatch(payActions.setPayMarkArray([0, 1, 0]));
          dispatch(payActions.setPayUseYear(cYear + 1));
          dispatch(payActions.setPayPrice("365.00"));
          this.setState({
            payType: 2,
          });
        } else {
          dispatch(payActions.setPayMarkArray([1, 0, 0]));
          dispatch(payActions.setPayUseYear(cYear + 2));
          dispatch(payActions.setPayPrice("365.00"));
          this.setState({
            payType: 3,
          });
        }
      } else {
        let userYear =
          this.props.userInfo.year === "" ? cYear : this.props.userInfo.year;
        if (userYear <= cYear) {
          dispatch(payActions.setPayMarkArray([0, 0, 1]));
          this.setState({
            payType: 3,
          });
        } else if (userYear === cYear + 1) {
          dispatch(payActions.setPayMarkArray([0, 1, 0]));
          this.setState({
            payType: 2,
          });
        } else {
          dispatch(payActions.setPayMarkArray([1, 0, 0]));
          this.setState({
            payType: 3,
          });
        }
      }
    });
  };
}
const mapStateToProps = (state) => {
  return {
    userInfo: state.user.userData.userInfo,
    uiPay: state.pay.uiStateData,
  };
};

export default connect(mapStateToProps)(PayNow);



// WEBPACK FOOTER //
// ./src/containers/Pay/components/PayNow/index.js